import { App } from 'vue';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $currency: (value: number | string, noDecimals?: boolean) => string;
    }
}

export default {
    install(app: App) {
        app.config.globalProperties.$currency = (value: number | string, noDecimals: boolean = false): string => {
            if (!value) return 'No value';

            const formattedValue = Number(value);

            if (isNaN(formattedValue)) return 'Invalid currency data type.';

            const options: Intl.NumberFormatOptions = {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: noDecimals ? 0 : 2,
                maximumFractionDigits: noDecimals ? 0 : 2
            };

            return new Intl.NumberFormat('en-US', options).format(formattedValue);
        };
    }
};
